module.exports = "<p>delete works!</p>\n"